import React from 'react';

import NavBar from './../../components/NavBar';
import { Footer } from '../../components/Footer/Footer';
import { CareerContact } from '../../components/CareerPage/CareerContact';
import { InterviewProcess } from '../../components/CareerPage/InterviewProcess';
import { JobListings } from '../../components/CareerPage/JobListings';
import { CoreValues } from '../../components/CareerPage/CoreValues';
import { CareerOverview } from '../../components/CareerPage/CareerOverview';
import { CareerHero } from '../../components/CareerPage/CareerHero';

// import { CAREER_PAGE_BODY_TEXT } from '../../constants/Careers';

import './index.css';

export const CareersPage = () => {
  return (
    <>
      <NavBar currentPath="careers" />
      <div className="careers-page-body-wrapper">
        {/* <div className="careers-page-body-text-wrapper">{CAREER_PAGE_BODY_TEXT}</div> */}
        <CareerHero />
        <CareerOverview />
        <CoreValues />
        <InterviewProcess />
        <JobListings />
        <CareerContact />
      </div>
      <Footer currentPath={'/careers'} />
    </>
  );
};
